// GC Living — square lens magnifier (loupe) for zoomable product images.
// Replaces Dawn's full-overlay hover zoom with a small square lens that
// follows the cursor and magnifies a local region at a higher ratio.

const GC_LENS_SIZE = 200; // px, square lens
const GC_ZOOM = 2.5;      // magnification factor

function gcLargestSrc(image) {
  // Prefer the highest-resolution URL from srcset for a crisp zoom.
  const srcset = image.getAttribute('srcset') || image.getAttribute('data-srcset');
  if (!srcset) return image.currentSrc || image.src;
  let best = image.currentSrc || image.src, bestW = 0;
  srcset.split(',').forEach((part) => {
    const seg = part.trim().split(/\s+/);
    const url = seg[0];
    const w = seg[1] && seg[1].endsWith('w') ? parseInt(seg[1]) : 0;
    if (w >= bestW) { bestW = w; best = url; }
  });
  return best;
}

function gcCreateLens(image) {
  // Attach the lens next to the image (same coordinate space) instead of the
  // document body: position:fixed breaks when any ancestor has a CSS
  // transform (theme scroll animations), which left the lens stuck in a corner.
  const parent = image.parentElement;
  if (getComputedStyle(parent).position === 'static') parent.style.position = 'relative';
  const lens = document.createElement('div');
  lens.className = 'gc-magnify-lens';
  lens.setAttribute('aria-hidden', 'true');
  Object.assign(lens.style, {
    position: 'absolute',
    boxSizing: 'border-box',
    width: GC_LENS_SIZE + 'px',
    height: GC_LENS_SIZE + 'px',
    borderRadius: '6px',
    border: '2px solid rgba(255,255,255,.9)',
    boxShadow: '0 4px 18px rgba(0,0,0,.35)',
    backgroundColor: '#fff',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `url('${gcLargestSrc(image)}')`,
    pointerEvents: 'none',
    zIndex: '9999',
    display: 'none',
    cursor: 'crosshair'
  });
  parent.appendChild(lens);
  return lens;
}

function gcMove(image, lens, event) {
  // offsetX/Y are in the image's own layout space, immune to ancestor transforms
  const x = event.offsetX;
  const y = event.offsetY;
  const w = image.offsetWidth;
  const h = image.offsetHeight;
  if (x < 0 || y < 0 || x > w || y > h) { lens.style.display = 'none'; return; }
  lens.style.display = 'block';

  const bgW = w * GC_ZOOM;
  const bgH = h * GC_ZOOM;
  lens.style.backgroundSize = `${bgW}px ${bgH}px`;

  // centre the magnified point under the cursor, clamped to image bounds
  let bgX = x * GC_ZOOM - GC_LENS_SIZE / 2;
  let bgY = y * GC_ZOOM - GC_LENS_SIZE / 2;
  bgX = Math.max(0, Math.min(bgX, bgW - GC_LENS_SIZE));
  bgY = Math.max(0, Math.min(bgY, bgH - GC_LENS_SIZE));
  lens.style.backgroundPosition = `-${bgX}px -${bgY}px`;

  lens.style.left = (image.offsetLeft + x - GC_LENS_SIZE / 2) + 'px';
  lens.style.top = (image.offsetTop + y - GC_LENS_SIZE / 2) + 'px';
}

function gcEnableLens(image) {
  if (image.dataset.gcLensBound) return;
  image.dataset.gcLensBound = '1';
  let lens = null;
  image.addEventListener('mouseenter', () => { if (!lens) lens = gcCreateLens(image); lens.style.backgroundImage = `url('${gcLargestSrc(image)}')`; });
  image.addEventListener('mousemove', (e) => { if (!lens) lens = gcCreateLens(image); gcMove(image, lens, e); });
  image.addEventListener('mouseleave', () => { if (lens) lens.style.display = 'none'; });
}

function enableZoomOnHover() {
  // Only on devices with a fine pointer (desktop); touch keeps native behaviour.
  if (window.matchMedia && !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  document.querySelectorAll('.image-magnify-hover').forEach(gcEnableLens);
}

enableZoomOnHover();
document.addEventListener('DOMContentLoaded', enableZoomOnHover);
